export type DaasComponentPickerConfig = {
  type: string;
  entityRef: string;
  relationsValidation: boolean;
  dependencyOf: string[];
};

export const COMPONENT_TYPES = {
  APPLICATION: 'daas-application',
  APPLICATION_SET: 'daas-application-set',
  PROJECT: 'daas-project',
} as const;
